module.exports = __webpack_public_path__ + "img/Les_Get_Active.819b515e.png";